import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import type {
	LWApiPublicAssetReportRelatedTerminationActionsParamsRawI,
	LWApiPublicAssetReportRelatedTerminationActionsRawI,
} from '@liquidweb-dev/club-sauce/public/asset/index.raw';
import type { ApiErrorI } from '@liquidweb-dev/club-sauce/types/apiError';
import api from 'modules/queries/api';

export const ASSET_REPORT_RELATED_TERMINATION_ACTIONS_QUERY_KEY =
	'/asset/reportRelatedTerminationActions';

const useAssetReportRelatedTerminationActions = (
	params: LWApiPublicAssetReportRelatedTerminationActionsParamsRawI,
	options?: UseQueryOptions<
		LWApiPublicAssetReportRelatedTerminationActionsRawI,
		ApiErrorI
	>,
) => {
	return useQuery({
		queryKey: [ASSET_REPORT_RELATED_TERMINATION_ACTIONS_QUERY_KEY, params],
		queryFn: () => api.asset.apiRaw.reportRelatedTerminationActions(params),
		...options,
	});
};

export default useAssetReportRelatedTerminationActions;
